export default {
  alerts: []
};
